<template>
  <header

    :class="{
      transparent: isTransparent,
      'no-shadow': isNoShadow,
    }"
  >
    <nav style="height:100%">
      <ul style="height:100%">
        <li style="padding-left: 24px; padding-right: 0"  @click="changeMenu(1, '/')">
          <img class="logo" src="@/assets/images/apj-logo.png" />
        </li>
        <li
          :class="activeIndex == 1 ? 'active' : ''"
          @click="changeMenu(1, '/')"
        >
          首页
        </li>
        <li
          :class="activeIndex == 2 ? 'active' : ''"
          @click="changeMenu(2, '/service')"
        >
          数字化服务
        </li>
        <li
          @mouseover="showPu = true"
          @mouseout="hanldeFasle"
          class="pi-rela pi-align-center"
          :class="activeIndex == 3 ? 'active' : ''"
          @click="changeMenu(3, '/product')"
        >

          产品与方案
          <!-- <i class="el-icon-arrow-down pi-mg-left-4 pi-fw-900"></i>
          <product-nav v-model="showPu"></product-nav> -->
        </li>
        <li
          :class="activeIndex == 4 ? 'active' : ''"
          @click="changeMenu(4, '/aboutus')"
        >
          关于我们
        </li>
      </ul>
    </nav>
    <!-- <div class="apj-nav">
        <img class="logo" src="@/assets/images/apj-logo.png" />
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="2">数字化服务</el-menu-item>
          <el-menu-item index="3">产品与方案</el-menu-item>
          <el-menu-item index="4">关于我们</el-menu-item>
        </el-menu>
      </div> -->
    <div class="search-content">
      <div
        class="pi-align-center"
        :style="{
          backgroundColor: showSearch ? 'rgba(255, 255, 255, 0.7)' : '',
        }"
      >
        <input
          v-show="showSearch"
          class="search-input"
          name="search"
          placeholder="搜索"
          @mouseover="toggleSearch(true)"
          @mouseout="toggleSearch(false)"
        />
        <div
          :style="{
            backgroundColor: showSearch ? '' : '',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '20px',
          }"
          @mouseover="toggleSearch(true)"
          @mouseout="toggleSearch(false)"
        >
          <i class="iconfont iconsousuo1 search-icon"></i>
        </div>
      </div>
      <!-- <img class="search-icon" :style="{
            backgroundColor: showSearch ? '#f5f5f5' : ''
          }" src="@/assets/images/search.png" @mouseover="toggleSearch(true)" @mouseout="toggleSearch(false)" /> -->
      <!-- <el-tooltip class="item" effect="dark" content="前往爱浦京软件技术（香港）有限公司" placement="bottom-end"> -->
      <el-dropdown :tabindex="0">
        <div class="network-container">
          <i class="iconfont iconicon- search-icon" style="color: #fff"></i>
          <!-- <img class="search-icon" src="@/assets/images/network.png" /> -->
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item onclick="location.href='/'"
            >China / 简体中文 <i class="el-icon-check"></i
          ></el-dropdown-item>
          <el-dropdown-item onclick="window.open('https://www.apjcorp.com.hk/')"
            >Hong Kong / English</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- </el-tooltip> -->
    </div>
  </header>
</template>

<script>
import ProductNav from "./nav";

export default {
  props: {
    isTransparent: {
      default: true,
      type: Boolean,
    },
    isNoShadow: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      product_Height: 340,
      product_idx: 0,
      showPu: false,
      showSearch: false,
      activeIndex: 1,
    };
  },
  created() {
    let that = this;
    that.activeIndex = 1;

    globalEvent.$on("changeMenu", (index) => {
      that.activeIndex = index || 1;
    });
  },
  mounted() {},
  components: { ProductNav },
  methods: {
    hanldeFasle(){
      console.log(1)
      this.showPu = false
      // setTimeout(()=>{
      //   this.showPu = false
      // },1000)
    },
    toggleSearch(show) {
      this.showSearch = show;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    changeMenu(index, url) {
      this.activeIndex = index;
      this.$router.push(url);
      // globalEvent.$emit('changeMenu', index)
    },
  },
};
</script>


<style lang="scss" scoped>
.nav_right {
  display: flex;
  padding: 36px 42px;
}
.nav_left {
  padding: 34px;
  width: 232px;
  white-space: nowrap;
  &_item {
    text-align: left;
    margin-bottom: 20px;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    color: #222222 !important;
    line-height: 32px;
    font-weight: bold;
    &-c {
      color: #e92131 !important;
    }
  }
}
.box {
  position: absolute;
  background-color: #fff !important;

  min-width: 937px;
  min-height: 312px;
  background: #ffffff;
  box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.15);
}
* {
  transition: all 0.5s;
}
@import "@/assets/theme.scss";

/**  replace element css */
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}

/** page style */
.apj-nav {
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

header {
  width: 100%;
  height: 70px;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  background-color: #fff;
  box-shadow: 0px 2px 3px #dddddd;
  z-index: 100;
}

.transparent {
  background-color: unset;
  color: $color-text-white;
  box-shadow: unset;

  div,
  span,
  li.active,
  i,
  input,
  search-content div {
    color: $color-text-white;
    background-color: rgba(0, 0, 0, 0);
  }

  li {
    color: rgba(255, 255, 255, 0.7);
  }
}

.no-shadow {
  box-shadow: unset;
}

nav ul {
  display: flex;
}

nav li {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  font-size: 18px;
  list-style: none;
}

nav li.active {
  font-weight: bold;
}

nav li:hover {
  cursor: pointer;
  font-weight: bold;
}

.logo {
  margin-right: 20px;
  height: 40px;
}

.search-input {
  width: 200px;
  height: 70px;
  flex: 1;
  padding: 0 20px;
  border: 0;
  // background-color: #f5f5f5;
  animation: showSearch 0.6s;
  -webkit-animation: showSearch 0.6s;
}

.search-input:focus {
  border: 0;
  outline: 0;
}

.search-content {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* width: 550px; */
  height: 70px;
  /* background-color: #f5f5f5; */
}

.search-icon {
  font-size: 32px;
  cursor: pointer;
}

.network-container {
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ec0022;
  cursor: pointer;
}

@keyframes showSearch {
  from {
    width: 0px;
  }
  to {
    width: 200px;
  }
}

/*Safari 和 Chrome:*/
@-webkit-keyframes showSearch {
  from {
    width: 0px;
  }
  to {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page-header/page-header.vue